import { useCookies } from "react-cookie";
import React, { useContext, useEffect, useState } from 'react';
import { TostMessageContext } from "../context/TostMessage";
import axios from "axios";
import { base_url } from "../url_variables";

export const useCart = () => {
  const [cookies, setCookie] = useCookies(["myCart"]);
  const { setTostMessage } = useContext(TostMessageContext);

  const addToCart = async (name, product_id, type, quantity, selected, total_price, thumbnail) => {
    console.log(selected)
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    const index = cart?.findIndex(
      item => item.product_id === product_id
    );

    let updatedCart;
    if (index !== -1) {
      cart[index] = {
        name,
        product_id,
        quantity,
        type,
        selected,
        total_price,
        thumbnail
      }
      updatedCart = cart;
      setTostMessage({
        messageType: 'success',
        message: 'Item replaced in Cart'
      })
    } else {
      updatedCart = [
        ...cart,
        { name, product_id, type, quantity, selected, total_price, thumbnail }
      ];
      setTostMessage({
        messageType: 'success',
        message: 'Item added to Cart'
      })
    }

    setCookie("myCart", updatedCart, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });

    if (cookies?.billingInfo?.email != undefined) {
      const formData = new FormData();
      formData.append('cart_data', JSON.stringify(updatedCart));
      formData.append('customer', cookies?.billingInfo?.email);
      
      try {
          const response = await axios.post(base_url + '/update_cart.php', formData, {
              headers: {
                  "Content-Type": "multipart/form-data",
              },
          });
          if (response.data.status) {
              // return response.data.in_stock;
          } else {
              // return 'N/A'
          }
      } catch (error) {
        // return 'N/A'
      }
    }

    // console.log(JSON.stringify(updatedCart));
  };

  const removeItem = async (product_id) => {
    // const cart = cookies.myCart || [];
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    const index = cart?.findIndex(
      item => item.product_id === product_id
    );

    const updatedCart = cart;
    updatedCart.splice(index, 1);

    setCookie("myCart", updatedCart, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });

    setTostMessage({
      messageType: 'success',
      message: 'Item removed from Cart'
    })

    if (cookies?.billingInfo?.email != undefined) {
      const formData = new FormData();
      formData.append('cart_data', JSON.stringify(updatedCart));
      formData.append('customer', cookies?.billingInfo?.email);

      try {
          const response = await axios.post(base_url + '/update_cart.php', formData, {
              headers: {
                  "Content-Type": "multipart/form-data",
              },
          });
          if (response.data.status) {
              // return response.data.in_stock;
          } else {
              // return 'N/A'
          }
      } catch (error) {
        // return 'N/A'
      }
    }
  }

  const getCartTotal = () => {
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    return cart?.length;
  }

  const checkItemInCart = (product_id) => {
    const cart = Array.isArray(cookies.myCart) ? cookies.myCart : [];
    const item = cart?.find(i => i.product_id === product_id)
    return item ? item.quantity : 0
  }

  function convertAmount(amount) {
    if (cookies?.user_country == "NG") {
      return 'NGN ' + Number(amount).toLocaleString("en-US")
    } else {
      return '$ ' + Number(amount/cookies?.exchange_rate).toLocaleString("en-US")
    }
  }

  function replaceCart(new_cart_items) {
    setCookie("myCart", new_cart_items, {
      path: "/",
      maxAge: 60 * 60 * 24, // 24 hours (SECONDS)
      secure: true,
      sameSite: "strict"
    });
  }

  return {
    cart: cookies.myCart || [],
    addToCart,
    getCartTotal,
    checkItemInCart,
    removeItem,
    convertAmount,
    replaceCart
  };
};
